<template>

	<div id="account-options-menu" class="side-menu right closed">
		<!-- SVG PLUS -->
		<svg class="svg-plus">
			<use xlink:href="#svg-plus"></use>
		</svg>
		<!-- /SVG PLUS -->
		<!-- SIDE MENU TITLE -->
		<p class="side-menu-title">Your Account</p>
		<!-- /SIDE MENU TITLE -->

		<button @click.prevent="showLoginModal()" class="button medium secondary">
			Log in
		</button>
	</div>

</template>


<script>

    export default {

        methods: {


            showLoginModal () {
                this.$modal.show('LoginModal',)

            },

        },
    }
</script>